import { render } from "./ListeMenu.vue?vue&type=template&id=2d8e43cc&ts=true"
import script from "./ListeMenu.vue?vue&type=script&lang=ts"
export * from "./ListeMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__